import React, { useState } from 'react';
import { HelpCircle, ChevronDown, ChevronUp, Mail, MessageSquare, ShieldQuestion } from 'lucide-react';
import './HelpCenterPage.css';
import CommonHeader from '../components/CommonHeader';
import Footer from '../components/Footer';

const HelpCenterPage = () => {
  // Array of FAQs mapping typical platform questions
  const faqsData = [
    {
      question: "How do students unlock new quiz levels?",
      answer: "Students earn progress points by completing quizzes within specific subjects and topics. Once a student reaches a mastery threshold in their current level, the next level unlocks automatically, providing a gamified learning progression."
    },
    {
      question: "Where can parents view student progress reports?",
      answer: "Parents can access comprehensive tracking metrics through the unique parent portal segment. Navigating to the student tracking route updates your dashboard panel view with live accuracy percentages, level history, and completed modules."
    },
    {
      question: "How do we download printable worksheets and certificates?",
      answer: "When a topic is successfully mastered or a milestone tier is achieved, a download prompt automatically appears on the student's dashboard. You can also visit your rewards history layout tab to re-download or print previous certificates."
    },
    {
      question: "Can I manage multiple student profiles under one account?",
      answer: "Yes! The parent portal panel allows you to register and toggle between multiple student accounts from a single parent login dashboard, making it easy to track individual academic growth routes."
    }
  ];

  // Tracks which specific accordion index item is currently expanded
  const [expandedFaq, setExpandedFaq] = useState(null);

  const toggleFaq = (index) => {
    setExpandedFaq(expandedFaq === index ? null : index);
  };

  return (
    <div className="landing-wrapper">
      <CommonHeader />
      
      <main className="help-container">
        {/* HERO HERO HERO HERO SECTION */}
        <section className="help-hero">
          <div className="help-hero-content">
            <div className="help-badge">
              <ShieldQuestion size={18} />
              <span>Support Portal</span>
            </div>
            <h1>How can we help you today?</h1>
            <p>Find answers to common questions about your learning adventure or connect directly with our support team.</p>
          </div>
        </section>

        <div className="help-grid-layout">
          {/* LEFT SECTION: INTERACTIVE ACCORDION FAQS */}
          <section className="faq-section">
            <div className="section-header-inline">
              <HelpCircle size={24} className="accent-icon" />
              <h2>Frequently Asked Questions</h2>
            </div>
            
            <div className="accordion-group">
              {faqsData.map((faq, index) => {
                const isCurrentExpanded = expandedFaq === index;
                return (
                  <div 
                    key={index} 
                    className={`accordion-item ${isCurrentExpanded ? 'is-open' : ''}`}
                  >
                    <button 
                      className="accordion-trigger" 
                      onClick={() => toggleFaq(index)}
                      aria-expanded={isCurrentExpanded}
                    >
                      <span>{faq.question}</span>
                      {isCurrentExpanded ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
                    </button>
                    <div className="accordion-panel">
                      <div className="accordion-content">
                        <p>{faq.answer}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </section>

          {/* RIGHT SECTION: SUPPORT INFORMATION CARDS */}
          <aside className="support-sidebar">
            <h2>Direct Support</h2>
            <p className="sidebar-subtitle">Our support team typically replies within a few hours.</p>
            
            <div className="support-cards-stack">
              {/* WHATSAPP SUPPORT CHANNELS CHANNEL */}
              <a 
                href="https://wa.me/918328978944" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="support-card whatsapp-card"
              >
                <div className="support-card-icon">
                  <MessageSquare size={26} fill="currentColor" />
                </div>
                <div className="support-card-info">
                  <h3>Chat via WhatsApp</h3>
                  <p>Fast, direct mobile messaging assistance for quick configuration loops.</p>
                  <span className="action-link-text">Open WhatsApp Chat →</span>
                </div>
              </a>

              {/* EMAIL SUPPORT MODULE */}
              <a 
                href="mailto:support@knolup.com" 
                className="support-card email-card"
              >
                <div className="support-card-icon">
                  <Mail size={26} />
                </div>
                <div className="support-card-info">
                  <h3>Email Support</h3>
                  <p>Send us an academic tracking question or data verification query anytime.</p>
                  <span className="action-link-text">support@knolup.com →</span>
                </div>
              </a>
            </div>
          </aside>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default HelpCenterPage;